export { default as WRM } from './WRM';
export { default as withWRMDependencies } from './with-wrm-dependencies';
